import { getSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ROOM_UI_HIDE,
  ROOM_UI_HIDE_QUERY_PARAM_NAME,
  ROOM_UI_HIDE_QUERY_PARAM_VALUE_SEPARATOR
} from "@youm-front/room/domain";

const selectRouter = createFeatureSelector<RouterReducerState>("router");
const { selectQueryParam } = getSelectors(selectRouter);

const roomUiHide = createSelector(
  selectQueryParam(ROOM_UI_HIDE_QUERY_PARAM_NAME),
  (_) => {
    return _ ? _.split(ROOM_UI_HIDE_QUERY_PARAM_VALUE_SEPARATOR) : [];
  }
);

export const roomUiWithBackButton = createSelector(roomUiHide, (_) => {
  return !_.includes(ROOM_UI_HIDE.backButton);
});
export const roomUiWithInviteGuests = createSelector(roomUiHide, (_) => {
  return !_.includes(ROOM_UI_HIDE.inviteGuests);
});
export const roomUiWithRecording = createSelector(roomUiHide, (_) => {
  return !_.includes(ROOM_UI_HIDE.recording);
});
export const roomUiWithDestinations = createSelector(roomUiHide, (_) => {
  return !_.includes(ROOM_UI_HIDE.destinations);
});
